import { render, staticRenderFns } from "./OsReabertasComponent.vue?vue&type=template&id=1be45c40&"
import script from "./OsReabertasComponent.vue?vue&type=script&lang=js&"
export * from "./OsReabertasComponent.vue?vue&type=script&lang=js&"
import style0 from "./OsReabertasComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports